import type { Component } from '../../../core';
import { Container } from '../../display';

export interface View2DComponentOptions {
  layer?: string;
  view?: Container;
}

export class View2DComponent implements Component<View2DComponentOptions> {
  public static readonly NAME = 'view2d';

  public layer!: string;
  public view!: Container;

  public init(options: View2DComponentOptions = {}): void {
    this.layer = options.layer || 'default';
    this.view = options.view || new Container();
  }
}
